import dashboard from './stats/dashboard';

const stats = {
  namespaced: true,
  modules: {
    dashboard,
  },
};

export default stats;
